import { Component, DestroyRef, inject, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import * as _ from 'underscore';
import { ErrorService } from '../../../../../@core/utils/error.service';
import { SessionService } from '../../../../../@core/utils/session.service';
import { PoolTypeDTO } from '../../../../modules/pick-plan/models/pool-type-dto';
import { PoolService } from '../../../services/pool.service';
import { PoolListDataSource } from '../pool-list-datasource';

@Component({
  selector: 'pool-details',
  templateUrl: './pool-details.component.html',
  styleUrls: ['./pool-details.component.scss']
})
export class PoolDetailsComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  
  //#region Properties
  dataSource: PoolListDataSource;
  public editPool: PoolTypeDTO = {};
  public editActive = false;
  public poolLoading: boolean = false;
  public submitting: any;
  //#endregion

  //#region ViewChild Properties
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  //#endregion

  //#region Constructor with dependencies
  constructor(
    private poolService: PoolService,
    private errorService: ErrorService,
    public dialogRef: MatDialogRef<any>,
    private sessionService: SessionService
  ) { }
  //#endregion

  ngOnInit() {
    this.dataSource = new PoolListDataSource(this.paginator, this.sort);
    this.poolLoading = true;

    this.editPool = this.sessionService.selectedPoolType;
    if (this.editPool === null || this.editPool === undefined) {
      this.editPool = {};
      this.editActive = true;
      this.poolLoading = false;
    }

    this.poolService.getPoolTypes().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:data => {
      data = _.sortBy(data, 'name');
      this.dataSource.data = data;

      if (this.paginator) this.paginator._changePageSize(this.paginator.pageSize);
      this.poolLoading = false;
    }, error:err => { this.errorService.handleError(err); this.poolLoading = false; }});
  }

  savePoolClicked() {
    if (this.editPool.isActive === null || this.editPool.isActive === undefined) { this.editPool.isActive = false; }

    if (this.editPool.id !== null && this.editPool.id !== undefined) {
      // Close immediately and let PoolListComponent perform the actual
      // update in the background.
      this.editActive = false;
      this.dialogRef.close({
        backgroundSave: true,
        isNew: false,
        pool: { ...this.editPool }
      });
      return;
    }

    // New record: close immediately; PoolListComponent creates the pool in
    // the background so the user isn't stuck waiting on this dialog for the
    // network round trip.
    this.submitting = true;
    setTimeout(() => {
      this.editActive = false;
      this.dialogRef.close({
        backgroundSave: true,
        isNew: true,
        pool: { ...this.editPool }
      });
    }, 200);
  }

  cancelClicked(cancelled: boolean = false) {
    this.editActive = false;
    this.editPool = {};
    this.dialogRef.close(cancelled);
  }

}
